import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import GenerateClaimSearchForm from './GenerateClaimSearchForm';
import SearchView from "../../../widgets/SearchView";
import withMenuPermission from "../../../widgets/withMenuPermission";
import { ViewContainer } from "./../../../View.jsx";
import ViewUtils from "../../../ViewUtils";
import AlertItem from "../../../widgets/AlertItem";

const utils = new ViewUtils();
const toolbarRef = React.createRef();

const headCells = [
    { id: 'LearnerName', numeric: false, disablePadding: false, label: 'Learner Name' },
    { id: 'LearnerIDNumber', numeric: false, disablePadding: false, label: 'Learner ID Number' },
    { id: 'TrancheType', numeric: false, disablePadding: false, label: 'Tranche Type' },
    { id: 'TrancheAmount', numeric: false, disablePadding: false, label: 'Tranche Amount' },
    { id: 'OrganisationSDLNumber', numeric: false, disablePadding: false, label: 'Organisation SDL Number' },
    { id: 'InterventionCode', numeric: false, disablePadding: false, label: 'Intervention Code' },
    { id: 'SocioEconomicStatus', numeric: false, disablePadding: false, label: 'SocioEconomicStatus' }
];


class GenerateClaimSearch extends Component {

    constructor(props) {
        super(props);

        

        this.state = {
            selectedClaims: null,
            model: {
                InterventionID: null,
                EmployerID: null,
                DiscretionaryGrantTypeID: null,
                SocioEconomicStatusID: null,
                FinancialYearID: null,
                TrancheTypeID: null,
            },
            keyUpSwitch: false,
            message: null,
            messageStyle: null,
            showTable: true

        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        {id: 'generateClaim', label: 'Generate Claim', icon: 'CreateIcon', tooltip: 'Generate Claim For Selected Records',disabled: utils.isNull(this.state.selectedClaims)}
                    ]
                }
            ]
        };

    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    handleSelections = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedClaims: selection, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("generateClaim", selection.length === 0);
                }
            )
        } else {
            this.setState({ selectedClaims: null, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("generateClaim", selection.length === 0);
                }
            )
        }
    }

    handleFormValueChange = (values) => {
        if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
            this.setState({ model: values, selectedGrant: null });
        }
    }

    handleToolbarButtonClick = (buttonId) => {
        if (buttonId === "close") {
            this.props.history.push({
                pathname: '/ProcessingNav'
            })
        } else if ("generateClaim" === buttonId) {
            this.generateClaimBulk();
            toolbarRef.current.setButtonDisabled("generateClaim", true);
        }
    }

    successCallback(response) {
        this.setState({ message: response.Message, messageStyle: response.MessageType, selectedClaims: null, showTable: false }, () => {
            this.setState({ showTable: true })
        });
    }

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    generateClaimBulk = () => {
        let IDs = this.state.selectedClaims.map(e => e.Id);
        let data = {
            IDs: IDs,
            Type: this.state.model.DiscretionaryGrantTypeID.Id
        }
        let url = "api/sims/GenerateClaim/GrantClaimNumberUpdate";
        utils.invokeUrl(url, (response) => {
            var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();
            toolbarRef.current.setButtonDisabled("generateClaim", true);
            this.successCallback(response);
            IDs = null;
            data = null;
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(data)
            }
        )
    };

    render() {

        return (
            <ViewContainer title="">
                <p className="breadcrumbs">
                    {"Grant Processing > Generate Claims"}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                {this.state.showTable === true && (
                <SearchView headCells={headCells} dataUrl="api/sims/GenerateClaim/grantClaimInterventionGetDetails" 
                    model={this.state.model} toolbarConfig={this.toolbarConfig} searchParameters={this.searchParameters}
                    onLookupValueChange={this.props.onLookupValueChange} 
                    toolbarRef={toolbarRef}
                    history={this.props.history}
                    searchLabel={"SEARCH"}
                    multiSelect={true}
                    handleObject={true}
                    autoFetchData={false}
                    keyUpSwitch={this.state.keyUpSwitch}
                    hasButtonClickHandler={true} buttonClickHandler={this.handleToolbarButtonClick}
                        setSelection={(selection) => { this.handleSelections(selection) }}
                        showSelectedCount={true}
                >
                    <GenerateClaimSearchForm data={this.state.model}
                        valueChangeHandler={(values) => this.handleFormValueChange(values)}  />
                    </SearchView>
                )}
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(GenerateClaimSearch));



